import merge from 'deepmerge';
import { aurora } from '@indeed/ifl-themes';
import { createCustomPropertyTheme } from './utils.js';

const DEFAULT_THEME = createCustomPropertyTheme(aurora);
const EMPTY_OBJECT = {};
const parentThemeMap = new WeakMap();
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function getTheme() {
  let parentTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  let thisTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  if (isEmpty(parentTheme)) {
    parentTheme = EMPTY_OBJECT;
  }
  if (isEmpty(thisTheme)) {
    thisTheme = EMPTY_OBJECT;
  }
  let thisThemeMap;
  if (parentThemeMap.has(parentTheme)) {
    thisThemeMap = parentThemeMap.get(parentTheme);
    if (thisThemeMap.has(thisTheme)) {
      return thisThemeMap.get(thisTheme);
    }
  } else {
    thisThemeMap = new WeakMap();
    parentThemeMap.set(parentTheme, thisThemeMap);
  }
  const mergedTheme = mergeThemes(parentTheme, thisTheme);
  thisThemeMap.set(thisTheme, mergedTheme);
  return mergedTheme;
}
function mergeLast(_a, b) {
  return b;
}
function mergeThemes(parentTheme, thisTheme) {
  const thisThemeToMerge = typeof thisTheme === "object" ? createCustomPropertyTheme(thisTheme) : {};
  return merge.all([DEFAULT_THEME, parentTheme, thisThemeToMerge], {
    customMerge: key => {
      if (key === "breakpoints") {
        return mergeLast;
      }
      return undefined;
    }
  });
}

export { getTheme };
